import { Alert, IconButton } from '~/shared/ui'

export function ErrorAlert({ content, onClose }: { content: string; onClose: () => void }) {
  return (
    <div className="flex h-0 justify-end px-4">
      <div>
        <Alert
          className="w-[360px] -translate-y-[calc(100%+8px)]"
          appearance="ERROR"
          materialIcon="error"
          action={
            <IconButton
              className="text-alert-error-message"
              size="medium"
              container="small"
              materialIcon="close"
              onClick={onClose}
            />
          }
        >
          {content}
        </Alert>
      </div>
    </div>
  )
}
